// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"905f22d3","732":"f957402c","952":"26b32017","977":"f26c5ab6"}[chunkId] + ".chunk.js";
};